module.exports = __webpack_public_path__ + "img/start-scratch.0d33dfb2.jpeg";